<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-row justify="center">
      <v-col cols="12" sm="12">
        <title-big :title="$t('HomePage.header.forgot')" />
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6">
        <v-card class="elevation-12">
          <v-toolbar flat>
            <v-toolbar-title>
              {{ $t("ForgotPage.headline") }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-container>
                <v-text-field
                  filled
                  :label="$t('Headers.email')"
                  prepend-icon="mdi-account"
                  v-model="email"
                ></v-text-field>
              </v-container>
              <p>
                <custom-button
                  v-bind:block="true"
                  :loading="loadingState"
                  @click="Forgot"
                  :text="$t('ForgotPage.button')"
                />
              </p>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomButton from "../../components/ui/input/CustomButton";
import TitleBig from "@/components/ui/text/HeaderBig";
import { log } from "@/helpers/logger";

export default {
  name: "Login",
  components: {
    CustomButton,
    TitleBig,
  },
  data() {
    return {
      email: "",
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    loadingsState() {
      return this.$store.state.loading;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/admin");
    }
  },
  methods: {
    async forgot() {
      this.$store
        .dispatch("auth/forgot", this.email)
        .then(() => {
          log(
            "AdminPage.Forgot.forgot() - send forgot mail to " + this.email,
            "info"
          );
          this.$router.push("/adminLogin");
        })
        .catch((err) => {
          log("AdminPage.Forgot.forgot() - " + err, "error");
        });
    },
  },
};
</script>
